import './int_tel_number.scss';

/**
 *  International Telephone Input directive
 *  http://www.tooorangey.co.uk/posts/that-international-telephone-input-umbraco-7-property-editor/
 *  https://github.com/Bluefieldscom/intl-tel-input
 *
 *  Directive renders a dropdown list of flags and international number prefixes.
 */
function intTelNumberDirective($bbug, $parse, CompanyStoreService) {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',

        link(scope, element, attrs, ctrl) {

            // By default set country prefix to one matching company.
            const initialCountry = CompanyStoreService.country_code || '';

            const options = Object.assign({
                utilsScript: require('intl-tel-input/build/js/utils').id, 
                separateDialCode: true,
                initialCountry
            }, scope.$eval(attrs.bbIntTelNumber));

            // Apply 3th party plugin for additional features.
            element.intlTelInput(options);

            // Set chooser width to match the inner input field's width.
            if (options.alignList) {
                element.parent().parent().find('ul').innerWidth(element[0].clientWidth);
            }

            const isValid = function (value) {
                if (value) {
                    return element.intlTelInput('isValidNumber');
                } else {
                    return true;
                }
            };

            if (attrs.prefix) {
                $bbug(element).on('countrychange', (e, countryData) => {
                    scope.$eval(`${attrs.prefix} = "${countryData.dialCode}"`);
                    format(ctrl.$viewValue);
                    ctrl.$render();
                });
            }

            ctrl.$render = function () {
                ctrl.$setViewValue(ctrl.$modelValue);
            };

            let format = function (value) {
                let str = '';
                if (attrs.prefix) {
                    if (scope.$eval(attrs.prefix) != null) {
                        str += (`+${scope.$eval(attrs.prefix)} `);
                    }
                } else {
                    if (scope.$eval(attrs.ngModel + '_prefix') != null) {
                        str += (`+${scope.$eval(attrs.ngModel + '_prefix')} `);
                    }
                }
                if (scope.$eval(attrs.ngModel) != null) {
                    str += scope.$eval(attrs.ngModel);
                }
                if (str[0] === '+') {
                    if (attrs.prefix) {
                        if (scope.$eval(attrs.ngModel) != null) {
                            element.intlTelInput('setNumber', `+${scope.$eval(attrs.prefix)} ${scope.$eval(attrs.ngModel)}`);
                        }
                    } else {
                        const number = scope.$eval(attrs.ngModel) || '';
                        element.intlTelInput('setNumber', `+${scope.$eval(attrs.ngModel + '_prefix')} ${number}`);
                    }
                    ctrl.$setValidity(attrs.ngModel, isValid(value));
                }
                return str;
            };


            const parse = function (value) {

                const prefix = element.intlTelInput('getSelectedCountryData').dialCode;

                // this one will remove country dial code in front, because it's already displayed in the flag field
                if (prefix && value) {
                    element.intlTelInput('setNumber', `${value.replace('+' + prefix, '')}`);
                }

                let getter;
                if (attrs.prefix) {
                    getter = $parse(attrs.prefix);
                } else {
                    getter = $parse(attrs.ngModel + '_prefix');
                }
                getter.assign(scope, prefix);
                ctrl.$setValidity(attrs.ngModel, isValid(value));
                return value;
            };

            ctrl.$formatters.push(format);
            ctrl.$parsers.push(parse);
        }
    };
}

angular
    .module('BB')
    .directive('bbIntTelNumber', intTelNumberDirective);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/int-tel-number/int_tel_number.directive.js